// Colocated strings for DuckDBQueryDialog (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by the SFC as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// NEW keys, unlike the other two folders: both strings (`title`, `exportToZip`) were HARDCODED ENGLISH in the
// template until S7 bit 2, so there is nothing to lift out of `locales.js`. Every one of
// the 10 locale files therefore carries the ENGLISH text on purpose — leaving a locale out
// would make the key fall back to the root composer, which since S8 bit 2 means English
// anyway (`fallbackLocale: 'en'`), but carrying it locally keeps the component's strings
// self-contained and its warnings quiet. Replace a file's values as translations land. `vi` (the
// 11th locale, 2026-10-28) shipped with both translated ("DuckDB" and "Zip" kept).
//
// The opt-in SQL runner's six keys (`query`; AM_ABSORPTION_PLAN F1) — `sql`, `run`,
// `runShortcut`, `rows`, `rowsTruncated` (`{count}`, `{max}`), `noRows` — are standalone
// asset-management's hard-coded English (its `row(s)` / ` (first 200 shown)` split into two
// whole sentences) and are TRANSLATED in all 11 files. `sql` is "SQL" everywhere; where "row(s)"
// has no natural form (it, pl) the count reads as a label ("Righe: {count}").
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
